import { render, staticRenderFns } from "./ModulePreview.vue?vue&type=template&id=37749e9d&scoped=true"
import script from "./ModulePreview.vue?vue&type=script&lang=js"
export * from "./ModulePreview.vue?vue&type=script&lang=js"
import style0 from "./ModulePreview.vue?vue&type=style&index=0&id=37749e9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37749e9d",
  null
  
)

export default component.exports